export const message = {
    INVALID_CREDENTIALS: "Wpisałeś błędne dane użytkownika",
    EXISTING_EMAIL: "Podany e-mail już istnieje"
}

export const response = {
    OK: 200,
    CREATED: 201,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401
}